import React, { useEffect, useState } from "react";
import { ExternalLink } from "lucide-react";
import { useQuote } from "./QuoteDialog";

/**
 * Floating Request-a-Quote button for mobile only.
 * Hidden on desktop (sticky header CTA is always visible there).
 * Hidden until the user has scrolled past the hero (~600px) to avoid
 * competing with the hero CTA.
 */
export default function MobileStickyCTA() {
  const { openQuote } = useQuote();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="mobile-sticky-cta"
      aria-hidden={!visible}
      className={`lg:hidden fixed left-4 right-4 bottom-4 z-40 transition-all duration-300 ${
        visible
          ? "opacity-100 translate-y-0 pointer-events-auto"
          : "opacity-0 translate-y-6 pointer-events-none"
      }`}
    >
      <button
        data-testid="mobile-sticky-quote-btn"
        onClick={openQuote}
        title="Opens in a new tab"
        className="group w-full inline-flex items-center justify-center gap-2 bg-teal hover:bg-[#0D6BB1] text-white font-bold px-6 py-4 rounded-xl shadow-2xl shadow-navy/40 transition-all duration-200 active:scale-[0.98]"
      >
        Request a Quote
        <ExternalLink className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </button>
    </div>
  );
}
